import React, { Component } from 'react';

import DateTimePicker from './DateTimePicker';
import moment from 'moment';
import 'moment/locale/nl';
import 'moment/locale/en-gb';
import 'moment/locale/de';

export default class TimePicker extends Component {
  defaultFormat = 'HH:mm';

  getValueFormat() {
    const props = this.props;
    return props.valueFormat || props.inputFormat || this.defaultFormat;
  }

  getInputFormat() {
    const props = this.props;
    return props.inputFormat || this.defaultFormat;
  }

  getDisplayFormat() {
    const props = this.props;
    return props.displayFormat || props.inputFormat || props.valueFormat || this.defaultFormat;
  }

  getRuleTime(type) {
    const props = this.props;
    if (!props.validation || !props.validation.rules) return null;

    const rule = props.validation.rules.find((rule) => rule.type === type);
    if (!rule || !rule.params || !rule.params[0]) return null;

    const format = this.getValueFormat();
    const formatted = moment(rule.params[0], format, true);
    return formatted && formatted.isValid() ? formatted : null;
  }

  render() {
    let {
      locale = 'en-gb',
      label, name, className, placeholder, valueFormat,
      inputFormat, displayFormat, timeIntervals, value, readOnly, disabled
    } = this.props;
    valueFormat = this.getValueFormat();
    inputFormat = this.getInputFormat();
    displayFormat = this.getDisplayFormat();

    moment.locale(locale);
    const minTime = this.getRuleTime('min') || moment('00:00', valueFormat, true);
    const maxTime = this.getRuleTime('max') || moment('23:59', valueFormat, true);

    return (
      <DateTimePicker
        label={label}
        name={name}
        className={className}
        value={value}
        minTime={minTime}
        maxTime={maxTime}
        valueFormat={valueFormat} //Input format
        inputFormat={inputFormat}
        displayFormat={displayFormat}
        placeholderText={placeholder}
        aria-required={!!this.props['aria-required']}
        //className="field__time"
        locale={locale}
        timeFormat={valueFormat} //Dropdown format
        timeIntervals={timeIntervals}
        showTimeSelect={true}
        showTimeSelectOnly={true}
        timeCaption={null}
        //isClearable={true}
        readOnly={readOnly}
        disabled={disabled}
        //hasIndicator={false}
        //calendarClassName="calendar"
        //dayClassName={date => "calendar__day"}
        //popperClassName="calendar__popper"

        onChange={this.props.onChange}
        onBlur={this.props.onBlur}
        onFocus={this.props.onFocus}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Common/TimePicker.js